/* eslint-disable max-len */
export default {
	contactEmail: 'dan3002.work@gmail.com',
	startDate: 2019,
	home: {
		roles: ['a Software Engineer', 'a DevOps Engineer', 'an AWS Authorized Instructor'],
	},
	about: {
		paragraphs: [
			'I had the opportunity to start college at the age of 16, and started working a year later (17 years old). My interests are in cloud computing as well as software development.',
			'Along with that, I also have experience in teaching, I was recognized as an AWS Authorized Instructor and was the main instructor in 2 Bootcamps in Vietnam.',
			'I am always open to new opportunities and challenges. If you would like to reach me, feel free to drop me a message in the email below.',
		],
	},
	others: [
		'<b>Languages: </b>English | Vietnamese: native.',
		'<b>Programming languages: </b>JavaScript, Python, Bash Script, SQL.',
		'<b>Frameworks & libraries: </b>NextJS, MERN Stack, ReactJS, Django.',
		'<b>Other tools: </b>Linux, Git, Docker, AWS, k8s, ...',
	],
	currentWork: {
		company: 'Drylab',
		role: 'Member of Technical Staff',
		timeline: 'Oct 2025 - Present',
		url: 'https://thedrylab.com/',
		linkedin: 'https://www.linkedin.com/company/drylab-ai/',
		tagline: 'The AI operating system for biomedical discovery.',
		description: 'Drylab is an AI-automated bioinformatics platform that lets life science teams handle their entire research workflow in one place — from searching and preparing datasets, to co-creating analysis plans, generating code, and running pipelines with a single click. It is purpose-built for biology: trained on biological datasets, experimental data, and scientific workflows, so it understands the science, not just the syntax.',
		videoId: 'I8_fgv6qW6Y',
		videoTitle: 'Drylab product overview',
		highlights: [
			{
				icon: 'fas fa-flask',
				title: 'Data Analysis',
				text: 'Co-create analysis plans with AI that generate and run code, outputting results alongside you.',
			},
			{
				icon: 'fas fa-search',
				title: 'Data Search',
				text: 'Custom search across GEO and beyond, with datasets automatically prepared for analysis.',
			},
			{
				icon: 'fas fa-toolbox',
				title: '800+ Tools',
				text: 'Brings together 800+ bioinformatics tools into one AI-automated platform.',
			},
			{
				icon: 'fas fa-shield-alt',
				title: 'Secure by Design',
				text: 'Encrypted "Vault" storage and a local-first Desktop App so sensitive data never leaves your machine.',
			},
		],
	},
	education: [{
		title: 'FPT University',
		timeline: 'Jan 2022 - Aug 2023',
		subtitle: 'Major: Software Engineering.',
		text: [
			'Graduated at the <b>age of 20</b>, two years ahead of schedule.',
			'Awarded a full scholarship covering the entirety of the study period.',
			// 'I am able to complete my undergraduate degree in a year and a half due to an exemption of 50% of required subjects in the entire study program.',
			// 'GPA: 8.0/10',
		],
	}, {
		title: 'FUNiX University',
		timeline: 'Aug 2018 - Dec 2021',
		subtitle: 'Major: Software Engineering.',
		text: [
			'Started studying at the <b>age of 16</b>.',
			'Received a scholarship each semester and actively participated in various university activities.',
			// 'Had the opportunity to have personal meetings with the university\'s principal (<a href="https://vi.wikipedia.org/wiki/Nguy%E1%BB%85n_Th%C3%A0nh_Nam_(doanh_nh%C3%A2n)">Mr. Nguyen Thanh Nam</a> - Founder of FUNiX, former General Director of FPT).',
			// 'GPA: 8.4/10',
		],
	}],
	experience: [{
		title: 'Drylab',
		timeline: 'Oct 2025 - Present',
		subtitle: 'Member of Technical Staff',
		text: [
			'Building an <a href="https://thedrylab.com/">AI-automated bioinformatics platform</a> that handles end-to-end research workflows, from data search and analysis to model training.',
			'Contributing to the development of an enterprise-grade platform empowering leading life science teams to accelerate their discovery phase.',
		],
	}, {
		title: 'VPBank',
		timeline: 'Aug 2024 - Sep 2025',
		subtitle: 'DevOps Engineer',
		text: [
			'Youngest Senior Specialist at @VPBank. (21 years old)',
			'Aligning ESB architecture with microservices and cloud environments, focusing on stability, performance, and scalability.',
			'Utilizing GitOps framework to automate monitoring, enabling proactive management and real-time issue resolution.',
			'Re-architecting existing APIs and services to integrate with modern microservices and message-oriented middleware (IBM MQ).',
			'Designing and implementing CI/CD pipelines to streamline deployment and testing, ensuring smooth integration and delivery of new features.',
		],
	}, {
		title: 'OpenCommerce Group',
		timeline: 'Mar 2024 - July 2024',
		subtitle: 'Full-Stack Developer',
		text: [
			'Participate in the development of the Dropshipping e-commerce system.',
			'Enhance and develop payment and related systems using Golang and VueJS. Integrate with payment services such as Stripe, PayPal, and others.',
		],
	}, {
		title: 'FUNiX',
		timeline: 'Aug 2021 - Feb 2024',
		subtitle: 'Full-Stack Developer & Program Development Officer',
		text: [
			'Contributed to the development of internal applications, including the Mentoring System and Learning Management System (LMS).',
			'Managed cloud-based resources for the entire team, ensuring efficient and secure access to the necessary tools and resources.',
			'Assumed responsibility for designing and developing xSeries specialized courses, including <b>Full Stack with MERN Stack, Data Engineering, Cloud Computing, and DevOps, ...</b>',
			// 'In addition, I collaborated with other instructors to create comprehensive curriculum for each course and provided hands-on training to students through practical projects and exercises. The courses I developed have received positive feedback from students and helped them achieve better results in their field.',
		],
	}, {
		title: 'FPT Software',
		timeline: 'Aug 2020 - Aug 2021',
		subtitle: 'Backend Developer',
		text: [
			'Balanced my role as a part-time employee while still attending high school, gaining valuable work experience while completing my education.',
			'Contributed to the development of internal applications, including the Mentoring System and Learning Management System (LMS).',
			// 'Assisted in the implementation and operation of projects by monitoring and resolving bugs.',
		],
	}, {
		title: 'FUNiX\'s IT department',
		timeline: 'Aug 2019 - Aug 2020',
		subtitle: 'Backend Developer',
		text: [
			'Started working immediately after my first year of university, at the age of 17, gaining valuable experience and skills while pursuing my education.',
			'Developed a learning tool and management software using Javascript, NodeJS, and Firebase, providing an interactive and user-friendly platform for students and instructors.',
			// 'Developed and deployed a Chrome Extension that translates subtitles on MOOC websites (such as Udemy and Coursera) and the content of the page into Vietnamese, providing a more accessible and user-friendly learning experience for students.',
		],
	}],
	activities: [{
		title: 'AWS Academy',
		timeline: 'Sep 2022 - Present',
		subtitle: 'AWS Authorized Instructor',
		text: [
			'Selected as a lecturer for the AWS Academy Cloud Training Bootcamp in Vietnam, organized by FUNiX and <a href="https://aws.amazon.com/training/awsacademy/">AWS Academy</a>, where I shared my knowledge and experience in the field of cloud computing with students.',
			'Assumed responsibility for instructing an <b>AWS Cloud Foundatio</b> and <b>AWS Solutions Architect - Associate</b> course, with a class size of nearly 800 students.',
		],
	}, {
		title: 'FUNiX',
		timeline: 'Oct 2021 - Present',
		subtitle: 'Mentor for the FUNiX\'s program',
		text: [
			'Assisted in providing answers to students\' inquiries regarding FUNiX subjects, with a focus on information technology and soft skills, ensuring that their academic and technical queries are resolved.',
			'Participated in the evaluation process by administering exams to determine student competence and readiness, ensuring they met course requirements.',
		],
	}, {
		title: 'JS Club - Japanese Software Engineers',
		timeline: 'May 2022 - Present',
		subtitle: 'Member - Academic Department',
		text: [
			// 'Instructed a class of 15 students in Java Object-Oriented Programming for a period of 10 weeks, resulting in all students passing the course at university level with a grade of 80% or higher.',
			// 'Actively participated in deploying contest environments for Competitive Programming competitions.',
			'My university club where we share knowledge and skills at programming and software development. We organize training classes that help with improving coding skills, academic events, tech sharing sessions and more.',
		],
	}, {
		title: 'Developh Vietnam',
		timeline: 'July 2021 - Dec 2021',
		subtitle: 'Techcontent Mentor',
		text: [
			'Mentor of the <a href="https://www.facebook.com/develophvn/photos/pcb.334074128129033/334072064795906/">DIY Camp</a> program, where I provided guidance and support to students in developing their own projects.',
			// 'Develop and maintain the official website for <a href="https://www.facebook.com/develophvn">Developh Vietnam</a> - a social enterprise that aims to make technology education accessible to children in Vietnam by conducting coding classes and has reached over 6,000 followers on Facebook.',
		],
	}, {
		title: 'Codelearn',
		timeline: 'Aug 2020 - Aug 2021',
		subtitle: 'Problem Setter and Blog Writer',
		text: [
			'Developed and reviewed competitive programming challenges for weekly and monthly contests, ensuring high-quality and engaging problems for participants.',
			'Achieved a top ranking on the leaderboard.',
		],
	}],
	projects: [
		{
			title: 'Real-Time Likelihood Engine for Personalized Financial Product Recommendations',
			tags: ['Fullstack', 'AI', 'Tech Lead'],
			role: 'Fullstack & DevOps Engineer',
			description: 'A real-time AI-driven likelihood engine designed to personalize product recommendations based on customer behavior and multi-channel data. It automates data collection, feature selection, model training, and deployment to maximize conversion rates, reduce compliance risks, and optimize customer engagement across all banking segments.',
			contents: [
				'Runner up of <b>Hack CX Together 2025</b>.',
				'Real-time customer propensity prediction',
				'Personalized product recommendations',
				'Automated model training & feature selection',
				'Scalable data processing pipeline',
				'Continuous optimization with MLOps integration',
				'Boost engagement and conversion rates',
			],
			techs: ['ReactJS', 'Go', 'AWS', 'PostgreSQL', 'Langchain'],
			images: [
				'/images/projects/tcb-hackathon/tcb-hackathon-project-2.png',
				'/images/projects/tcb-hackathon/tcb-hackathon-project-3.png',
				'/images/projects/tcb-hackathon/tcb-hackathon-project-4.png',
				'/images/projects/tcb-hackathon/tcb-hackathon-project-5.png',
				'/images/projects/tcb-hackathon/tcb-hackathon-project-6.png',
				'/images/projects/tcb-hackathon/tcb-hackathon-project-7.png',
				'/images/projects/tcb-hackathon/tcb-hackathon-project-8.png',
				'/images/projects/tcb-hackathon/tcb-hackathon-project-9.png',
				'/images/projects/tcb-hackathon/tcb-hackathon-project-10.png',
			],
		},
		{
			title: 'Architecture Design Generator',
			tags: ['Fullstack', 'AI', 'Tech Lead'],
			role: 'Fullstack & DevOps Engineer',
			description: 'An application designed to provide various functionalities to help users create and manage architecture design diagrams more effectively.',
			contents: [
				'With the power of ChatGPT 4, our application can provide users the ability to create architecture design from scratch with a more interactive and user-friendly experience.',
				'Champion of <b>VPBank Hackathon 2024</b>.',
			],
			techs: ['ReactJS', 'Langchain', 'Go', 'AWS'],
			images: ['/images/projects/architecture-design-generator.png'],
		},
		{
			title: 'Cloudflare CORS Proxy',
			tags: ['DevOps'],
			role: 'DevOps Engineer',
			description: 'A simple and efficient CORS (Cross-Origin Resource Sharing) proxy service built for Cloudflare Workers. This proxy allows web applications to bypass CORS restrictions by forwarding requests through the proxy server.',
			contents: [
				'All HTTP Methods: Supports GET, POST, PUT, DELETE, PATCH, etc.',
				'Custom Headers: Send custom headers via x-cors-headers',
				'Custom Request Body: Send custom body data via x-cors-body',
				'Method Override: Override HTTP method via x-cors-method',
				'Origin Whitelisting: Security through origin control',
				'URL Blacklisting: Prevent abuse with URL blocking',
				'Preflight Handling: Automatic OPTIONS request handling',
			],
			techs: ['JavaScript', 'Cloudflare'],
			source: 'https://github.com/DAN3002/cloudflare-cors-proxy',
			images: [],
		},
		{
			title: 'Autonomous Insight & Action Pipeline for Hospital Data',
			tags: ['Fullstack', 'AI'],
			role: 'Fullstack & DevOps Engineer',
			description: 'An AI-powered system that analyzes hospital data to detect issues, extract insights, and suggest actions — just like a virtual data analyst.',
			contents: [
				'This pipeline helps hospitals analyze both patient data and staff feedback. It detects unusual trends, visualizes patterns, and summarizes open-text responses. Hospital staff can ask questions in natural language, and the system will auto-generate answers, charts, or queries to support decision-making.',
				'Runner up of <b>NRC x FPT Hackathon 2024</b>.',
				// 'Detects anomalies and trends in hospital operations',
				// 'Summarizes open-ended staff or patient feedback',
				// 'Answers staff questions with AI-generated queries and charts',
				// 'Simplifies data analysis for non-technical users',
				// 'Scalable, reproducible, and easy to integrate',
			],
			techs: ['ReactJS', 'Langchain', 'Go', 'PostgreSQL', 'MongoDB', 'LLM'],
			images: ['/images/projects/nrc-hackathon.png'],
		},
		{
			title: 'JS Recruitment',
			tags: ['Fullstack', 'Tech Lead'],
			role: 'Fullstack & DevOps Engineer',
			description: 'JS Recruitment is a web application designed to streamline the recruitment process for the JS Club. This application simplifies candidate registration, survey management, interview coordination, and data handling for club administrators.',
			contents: [
				'Host customizable surveys for candidates to fill out during registration.',
				'Organize recruitment events with multiple shifts for better candidate scheduling.',
				'End to end recruitment process management',
			],
			techs: ['ReactJS', 'Supabase', 'Cloudflare'],
			images: ['/images/projects/js-recruitment.png'],
		},
		{
			title: 'Youtube Colab Proxy',
			tags: ['Fullstack', 'DevOps'],
			role: 'Fullstack & DevOps Engineer',
			description: 'A Python web application that provides a YouTube video streaming proxy with a built-in web player. Designed to work seamlessly in Google Colab environments while also supporting local development and deployment.',
			contents: [
				'Streaming & Playback: Direct YouTube streaming (via proxy), MP4 ≤720p support, range requests for seeking',
				'Search & Playlists: Keyword-based video search, playlist/channel support, paginated results',
				'Security & Config: SHA256 password, cookies/geo-bypass/proxy, language customization',
			],
			techs: ['Python'],
			source: 'https://github.com/DAN3002/Youtube-Colab-Proxy',
		},
		{
			title: 'Notion Calendar Restyle',
			tags: ['Fullstack'],
			role: 'Fullstack Engineer',
			description: 'A lightweight Chrome extension that injects CSS to make Notion Calendar cleaner and more consistent, inspired by Google Calendar’s visual cues.',
			contents: [
				'Event color = ribbon color: Sets every event’s background to its ribbon color so it matches how colors appear in Google Calendar.',
				'Notion tasks styling: Distinct styling per task type; completed tasks get a strikethrough and subdued color, mirroring Google Tasks behavior.',
				'Past events dimming: Events that have ended are automatically dimmed to reduce visual noise, similar to Google Calendar.',
			],
			techs: ['JavaScript', 'Chrome Extension'],
			source: 'https://github.com/DAN3002/Notion-Calendar-Restyle',
			images: [],
		},
		{
			title: 'IMDb-Crawler',
			tags: ['Crawler'],
			role: 'Data Engineer',
			description: 'A powerful Python-based web crawler that collects comprehensive movie information from IMDb using both GraphQL API and web scraping techniques. This tool can gather detailed movie data including basic information, reviews, and ratings for any type of movies based on customizable filters.',
			contents: [
				'Advanced movie filtering capabilities similar to IMDb\'s search engine, allowing users to search for movies based on various criteria such as genre, rating, and release year.',
				'Collects detailed movie information',
				'Comprehensive user review collection',
			],
			techs: ['Python', 'GraphQL', 'Selenium'],
			source: 'https://github.com/DAN3002/IMDb-Crawler',
		},
		{
			title: 'Tiktok Video Crawler',
			tags: ['Crawler'],
			role: 'Data Engineer',
			description: 'This is a simple Tiktok crawler that can be used to download videos from Tiktok.',
			contents: [
				'It uses the Tiktok API to get the video URL and then downloads the video using the requests library.',
				'It can download video from multiple hashtags or download by sound.',
			],
			techs: ['Python'],
			source: 'https://github.com/DAN3002/Tiktok-Crawler',
		},
		{
			title: 'Shopee Product Crawler',
			tags: ['Crawler'],
			role: 'Data Engineer',
			description: 'A specialized tool for crawling products on Shopee by shop, keyword, and other criteria, with a continuous update mechanism to keep data current.',
			contents: [
				'Collects comprehensive information, including product details, images, and comments, enabling dataset creation for search functionality, data analysis (DA), and AI model training.',
				'Achieved a dataset of 1 million fashion products, and 8 million images from over 8,000 shops on Shopee, supporting scalable data-driven insights and AI applications.',
			],
			techs: ['Python', 'Selenium'],
		},
		{
			title: 'E-commerce Template Base Crawler',
			tags: ['Crawler', 'Fullstack'],
			role: 'Fullstack Developer & Data Engineer',
			description: 'Building a crawler system that gathers e-commerce product data from various sources, brands, and shops. It uses XPath templates to extract product details such as name, price, and images, with continuous update mechanisms.',
			contents: [
				'<b>Provides an end-to-end experience</b>: includes a tool for creating templates, a web app for managing crawled data and crawl history, and a dynamic core crawler system.',
				'Users only need to create a template for a sample product link on the website, and the system will automatically crawl all related products based on the generated template.',
			],
			techs: ['Selenium', 'ReactJS', 'NodeJS', 'Python'],
		},
		{
			title: 'JS Codefest 2024',
			tags: ['Fullstack', 'Tech Lead'],
			role: 'Fullstack & DevOps Engineer',
			description: 'CODEFEST 2024 is a coding competition where participants relive their mischievous and vibrant childhood summers through programming. Competitors must program bots using specific commands to battle opponents, collect items, and overcome challenges, crafting unique strategies to win.',
			contents: [
				'Led the project as a Tech Leader, ensuring seamless execution across all project milestones.',
				'Designed and implemented deployment strategies and system architecture to enable a successful product launch.',
				'Provided technical direction, code reviews, and mentorship to ensure high-quality development practices.',
			],
			techs: ['NodeJS', 'SocketIO', 'AWS', 'Docker'],
			images: ['/images/projects/js-codefest-2024.png'],
		},
		{
			title: 'FinAInce Assistant',
			tags: ['AI', 'Fullstack', 'Tech Lead'],
			role: 'Fullstack Developer & Devops Engineer',
			description: 'FinAInce Assistant is a financial chatbot designed to provide various functionalities to help users manage their finances more effectively.',
			contents: [
				'With the power of ChatGPT, our chatbot predicts user behavior, automates basic tasks, and offers real-time financial insights.',
				'Champion of FUNiX ChatGPT Hackathon',
			],
			techs: ['ReactJS', 'Flask', 'GPC Cloud', 'Firebase', 'ChatGPT'],
			source: 'https://github.com/example/finaince-assistant',
			images: ['/images/projects/finaince-assistant.png'],
		},
		{
			title: 'FUNiX Learning Management System (LMS)',
			tags: ['Fullstack', 'Tech Lead'],
			role: 'Fullstack Developer & Team Leader',
			description: 'A web application that provides a platform for students and instructors to manage their courses, allowing them to access educational materials and interact with each other. Built from the OpenEdx open-source project.',
			contents: [
				'Built a comprehensive learning management system (LMS) for FUNiX, an online learning platform.',
				'Incorporated features such as course management, material access, and student-instructor interaction.',
				'Utilized the OpenEdx open-source project to accelerate development.',
			],
			techs: ['ReactJS', 'Django', 'MySQL', 'AWS Cloud'],
			images: ['/images/projects/funix-lms.png'],
		},
		{
			title: 'FUNiX Mentoring System (HF40)',
			tags: ['Fullstack', 'Tech Lead'],
			role: 'Fullstack Developer & Team Leader',
			description: 'Developed and maintained a web application that helps FUNiX students find mentors, allowing them to connect and communicate with each other. Built from the Rocket.Chat open-source project.',
			contents: [
				'Built and maintained a mentoring system that enables FUNiX students to connect with mentors.',
				'Developed key features for user interaction and communication within the system.',
				'Utilized the Rocket.Chat open-source project to power the chat and communication functionalities.',
			],
			techs: ['MeteorJS', 'MongoDB', 'GCP Cloud'],
			images: ['/images/projects/funix-mentoring.png'],
		},
		{
			title: 'DAN3002 Portfolio',
			tags: ['Fullstack'],
			role: 'Fullstack Developer',
			description: 'This is a single-page React application that displays my personal resume information and projects from Github. The application is built with React, CSS, and HTML and data is fetched from the Github API.',
			contents: [

			],
			techs: ['ReactJS', 'Github API', 'Cloudfalre'],
			source: 'https://github.com/DAN3002/DAN-Portfolio',
			images: ['/images/projects/dan-portfolio.png'],
		},
		{
			title: 'Doctor\'s Cyclop',
			tags: ['Fullstack', 'AI', 'Tech Lead'],
			role: 'Fullstack Developer & Devops Engineer',
			description: 'Created a website that implements the machine learning model for classifying the presence and correct placement of tubes on chest x-rays, allowing for easy access and practical application of the model by medical professionals.',
			contents: [
				'Top 3 FPT Edu Hackathon 2021 - beat over 100 teams from different Universities.',
			],
			techs: ['MeteorJS', 'MongoDB', 'AWS Cloud'],
			source: 'https://github.com/DAN3002/Doctors-Cyclop-Webapp',
			images: ['/images/projects/doctors-cyclop.png'],
		},
		{
			title: 'FUNiX Passport',
			tags: ['Fullstack', 'Tech Lead'],
			role: 'Fullstack Developer',
			description: 'Chrome Extension that translates subtitles on MOOC websites (such as Udemy and Coursera) and the content of the page into Vietnamese, providing a more accessible and user-friendly learning experience for students.',
			contents: [
				'Developed a Chrome Extension that translates subtitles and page content into Vietnamese for a better learning experience.',
				'Enhanced accessibility for Vietnamese students using MOOC platforms like Udemy and Coursera.',
				'Focused on improving the user interface and user experience for students learning through online courses.',
			],
			techs: ['JavaScript', 'Firebase', 'Chrome Extension'],
		},
		{
			title: 'Water Testing Instant',
			tags: ['Fullstack', 'Tech Lead'],
			role: 'Backend Developer & Cloud Engineer',
			description: 'Constructed a portable hand-sized device capable of measuring the turbidity and purity of water, complete with a native Android App and cloud service, providing an easy and efficient way to check water quality on the go.',
			contents: [
				'Built a portable device to measure water turbidity and purity with an Android App and cloud integration.',
				'Participated in FPT Edu Hackathon 2019 and secured a top 3 position, surpassing 30 teams from various universities.',
				'Developed the backend using ExpressJS and managed cloud services with Firebase to handle real-time data.',
			],
			techs: ['ExpressJS', 'Firebase'],
		},
	],
	certifications: [{
		name: 'AWS Certified Solutions Architect - Associate',
		category: 'AWS Certificate',
		thumb: '/images/achieves/cert/AWS Certified Solutions Architect - Associate_banner.png',
		image: '/images/achieves/cert/AWS Certified Solutions Architect - Associate.png',
		url: 'https://www.credly.com/badges/8c2432fa-b400-4ecf-ab18-783351e6128b',
		start: 'November 19, 2021',
		end: 'November 19, 2024',
	}, {
		name: 'AWS Certified Cloud Practitioner',
		category: 'AWS Certificate',
		thumb: '/images/achieves/cert/AWS Certified Cloud Practitioner_banner.png',
		image: '/images/achieves/cert/AWS Certified Cloud Practitioner.png',
		url: 'https://www.credly.com/badges/1f3d4dc4-c239-4003-a9c6-f0ee578bc31d',
		start: 'October 05, 2021',
		end: 'November 19, 2024',

	}, {
		name: 'AWS Academy Certified Educator',
		category: 'AWS Certificate',
		thumb: '/images/achieves/cert/AWS Academy Certified Educator.png',
		image: '/images/achieves/cert/AWS Academy Certified Educator.png',
		url: 'https://www.credly.com/badges/7b48e869-5319-4d9f-ae19-9ca358c1842e',
		start: 'October 05, 2021',
		end: 'April 14, 2024',

	}],
	achievements: [{
		name: 'VPBank Hackathon 2024',
		category: 'Hackathon',
		thumb: '/images/achieves/vpbank-hackathon-2024.png',
		image: '/images/achieves/vpbank-hackathon-2024-banner.jpg',
		date: 'June 2024',
		prize: 'Champion',
		text: [
			'An application designed to provide various functionalities to help users create and manage architecture design diagrams more effectively. With the power of ChatGPT 4, our application can provide users the ability to create architecture design from scratch with a more interactive and user-friendly experience.',
			'Beat over 150 teams from different Companies and Universities.',
		],
		link: [],
	},
	{
		name: 'FUNiX ChatGPT Hackathon',
		category: 'Hackathon',
		thumb: '/images/achieves/funix-chatgpt-hackathon.png',
		image: '/images/achieves/funix-chatgpt-hackathon-banner.jpg',
		date: 'May 2023',
		prize: 'Champion',
		text: [
			'Our team has won the first victory with the product "FinAInce Assistant - ChatGPT can take actions". This is a new Fintech product, built in nearly a month and using ChatGPT along with some special techniques to optimize operations for users related to finance. The success of the team is evidence of the great potential of ChatGPT in performing many tasks other than Q&A. With ChatGPT, the team has saved time and focused on product development effectively.',
		],
		link: [{
			text: 'Dự án trợ lý ảo ngân hàng giành quán quân ChatGPT Hackathon',
			url: 'https://vnexpress.net/du-an-tro-ly-ao-ngan-hang-gianh-quan-quan-chatgpt-hackathon-4603011.html',
		},
		{
			text: 'Sinh viên FUNiX chia sẻ về dự án vô địch ChatGPT Hackathon',
			url: 'https://vnexpress.net/sinh-vien-funix-chia-se-ve-du-an-vo-dich-chatgpt-hackathon-4604055.html',
		},
		],
	},
	{
		name: 'Hack CX Together 2025',
		category: 'Hackathon',
		thumb: '/images/achieves/hack-cx-together-2025.jpg',
		image: '/images/achieves/hack-cx-together-2025-banner.jpg',
		date: 'June 2025',
		prize: 'Runner Up',
		text: [
			'A real-time AI-driven likelihood engine designed to personalize product recommendations based on customer behavior and multi-channel data. It automates data collection, feature selection, model training, and deployment to maximize conversion rates, reduce compliance risks, and optimize customer engagement across all banking segments.',
		],
		link: [],
	},
	{
		name: 'NRC x FPT Hackathon 2024',
		category: 'Hackathon',
		thumb: '/images/achieves/nrc-hackathon.jpg',
		image: '/images/achieves/nrc-hackathon.jpg',
		date: 'Nov 2024',
		prize: 'Runner Up',
		text: [
			'An AI-powered system that analyzes hospital data to detect issues, extract insights, and suggest actions — just like a virtual data analyst.',
			'This pipeline helps hospitals analyze both patient data and staff feedback. It detects unusual trends, visualizes patterns, and summarizes open-text responses. Hospital staff can ask questions in natural language, and the system will auto-generate answers, charts, or queries to support decision-making.',
		],
		link: [],
	},
	{
		name: 'FPT Edu ResFes 2023',
		category: 'Research Festival',
		thumb: '/images/achieves/resfes-2023.jpg',
		image: '/images/achieves/resfes-2023-banner.jpg',
		date: 'August 2023',
		prize: 'Third Prize',
		text: [
			'- Discovered and developed an ecosystem to apply an AI model call Relahash. Achieving unparalleled accuracy and minimal latency in image retrieval for the fashion e-commerce landscape.',
			'- Designed and implemented a declarative crawling system that allows users to specify their requirements and let the system do the heavy lifting.',
			'- Built a rich dataset of 7.5M+ images from 8K+ shops across 30 websites.',
			'- Built a robust ecosystem on Kubernetes to seamlessly combine our dynamic crawler and AI model pipeline.',
		],
		link: [],
	}, {
		name: 'FPT Edu Hackathon 2021',
		category: 'Hackathon',
		thumb: '/images/achieves/hackathon-2021.png',
		image: '/images/achieves/hackathon-2021-banner.jpg',
		date: 'April 2021',
		prize: 'Third Prize',
		text: [
			'As the youngest team to participate. Won third prize in a competition with 104 teams from various universities, for building a web application that utilizes AI to assist doctors in diagnosing Covid-19.',
		],
		link: [{
			text: '4 học sinh lớp 12 làm sản phẩm AI hỗ trợ điều trị Covid-19',
			url: 'https://vnexpress.net/4-hoc-sinh-lop-12-lam-san-pham-ai-ho-tro-dieu-tri-covid-19-4269038.html?fbclid=IwAR16uIHcQHmSkyvecoIT_z8IwSujveLDKXw7wImasg-5WxNR1Iym9cMJMh0',
		}],
	}, {
		name: 'FPT Edu Hackathon 2019',
		category: 'Hackathon',
		thumb: '/images/achieves/hackathon-2019.jpg',
		image: '/images/achieves/hackathon-2019-banner.jpg',
		date: 'January 2020',
		prize: 'Third Prize',
		text: [
			'As the youngest team to participate. Won third prize out of 35 teams coming from different Universities. Our team achieved third prize in a competition for developing equipment to check the safety of water.',
		],
		link: [{
			text: 'Học sinh THPT giành giải \'FPT Edu Hackathon\' 2019',
			url: 'https://vnexpress.net/hoc-sinh-thpt-gianh-giai-fpt-edu-hackathon-2019-4042313.html',
		}],
	}],
	externalLinks: {
		blog: 'https://blog.dan3002.id.vn',
		blogRssFeed: 'https://blog.dan3002.id.vn/feed.xml',
	},
};
